import { ChangeEvent, KeyboardEvent, useRef } from "react";
import { actionBarMinWidthWrapper } from "src/components/common/common";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { XButtonForm } from "src/components/common/form/XButtonForm";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";

import { useEQM2020_R01Store } from "./Store_EQM2020_R01";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const EQM2020_R01SearchSection = ({ onEnterKeyDown }: Props) => {

	const { EQM2020_R01Filter, setEQM2020_R01Filter } = useEQM2020_R01Store();
	const { eqmTypeList, inspectionStatusList, yesNoList,  } = useCommonCodeStore();

  return (
    <SearchSectionForm>
		{/* EQM2020_R01Filter : {JSON.stringify(EQM2020_R01Filter)} */}
		
		<SearchDropDownForm
			label="설비구분"
			value={EQM2020_R01Filter.eqmType}
			optionList={eqmTypeList}
			onChangeItem={(selectedItem) => setEQM2020_R01Filter({ eqmType: selectedItem?.minorCd || '' })}
		/>
		
		<SearchDropDownForm
			label="점검유형"
			value={EQM2020_R01Filter.inspectType}
			optionList={inspectionStatusList}
			onChangeItem={(selectedItem) => setEQM2020_R01Filter({ inspectType: selectedItem?.minorCd || '' })}
		/>
		<SearchDropDownForm
			label="사용여부"
			value={EQM2020_R01Filter.inspectUse}
			optionList={yesNoList}
			onChangeItem={(selectedItem) => setEQM2020_R01Filter({ inspectUse: selectedItem?.minorCd || '' })}
		/>
	</SearchSectionForm>
  );
};